import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
// Copyright 1999-2020. Plesk International GmbH. All rights reserved.
import { findDOMNode } from 'react-dom';
import React, { Component, Children, createContext } from 'react';
var AutoClosableContext = createContext(null);

/**
 * This is helper component for handling outside clicks.
 * @since 0.0.42
 */
var AutoClosable =
/*#__PURE__*/
function (_Component) {
  _inherits(AutoClosable, _Component);

  function AutoClosable() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, AutoClosable);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(AutoClosable)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "children", []);

    _defineProperty(_assertThisInitialized(_this), "addChild", function (child) {
      _this.children.push(child);
    });

    _defineProperty(_assertThisInitialized(_this), "removeChild", function (child) {
      _this.children = _this.children.filter(function (item) {
        return item !== child;
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getIgnoreNodes", function () {
      var ignoreNodes = _this.props.ignoreNodes;
      var nodes = typeof ignoreNodes === 'function' ? ignoreNodes() : [];
      nodes.push(_assertThisInitialized(_this));

      _this.children.forEach(function (child) {
        return child.getIgnoreNodes().forEach(function (node) {
          return nodes.push(node);
        });
      });

      return nodes;
    });

    _defineProperty(_assertThisInitialized(_this), "onOutsideClick", function (event) {
      var el = event.target;

      var isClickOnIgnoredNode = _this.getIgnoreNodes().map(function (node) {
        if (node instanceof AutoClosable && node.props.nodeRef && node.props.nodeRef.current) {
          return node.props.nodeRef.current;
        }

        if (node instanceof Component) {
          return findDOMNode(node);
        }

        if (node instanceof Node) {
          return node;
        }

        if (node && node.current instanceof Node) {
          return node.current;
        }

        return null;
      }).some(function (node) {
        return Boolean(node && el instanceof Node && node.contains(el));
      });

      if (isClickOnIgnoredNode) {
        return;
      }

      if (_this.props.onClose) {
        _this.props.onClose();
      }
    });

    return _this;
  }

  _createClass(AutoClosable, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.body.addEventListener('click', this.onOutsideClick);

      if (this.context) {
        this.context.addChild(this);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.body.removeEventListener('click', this.onOutsideClick);

      if (this.context) {
        this.context.removeChild(this);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(AutoClosableContext.Provider, {
        value: this
      }, Children.only(this.props.children));
    }
  }]);

  return AutoClosable;
}(Component);

AutoClosable.contextType = AutoClosableContext;
export default AutoClosable;